/* eslint-disable @typescript-eslint/no-explicit-any */
import { Workbook } from '@syncfusion/ej2-excel-export';
import { extend, isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * Excel Export Module
 */
export class ExcelExport {
    constructor(parent) {
        this.parent = parent;
    }
    initializeExcelExport(excelExportOptions = {}) {
        const exportColumns = this.getExportColumns(excelExportOptions);
        const exportName = excelExportOptions.fileName || 'Schedule';
        const exportType = excelExportOptions.exportType || 'xlsx';
        const isIncludeOccurrences = excelExportOptions.includeOccurrences || false;
        let separator;
        if (!isNullOrUndefined(excelExportOptions.separator) && excelExportOptions.separator !== ',') {
            separator = excelExportOptions.separator;
        }
        let eventCollection;
        if (excelExportOptions.customData) {
            eventCollection = !isIncludeOccurrences ? excelExportOptions.customData :
                this.parent.eventBase.getProcessedEvents(excelExportOptions.customData);
        }
        else {
            eventCollection = !isIncludeOccurrences ? this.parent.eventsData : this.parent.eventsProcessed;
        }
        this.processWorkbook(exportColumns, exportName, exportType, eventCollection, separator);
    }
    processWorkbook(fields, name, type, eventCollection, separator) {
        const columns = [];
        const rows = [];
        const columnHeader = [];
        fields.forEach((field, i) => { columns.push({ index: i + 1, width: (field.name === 'Id' ? 50 : 150) }); });
        const style = { fontSize: 12, borders: { color: '#E0E0E0' }, bold: true };
        fields.forEach((field, i) => { columnHeader.push({ index: i + 1, value: field.text, style: style }); });
        rows.push({ index: 1, cells: columnHeader });
        eventCollection.forEach((event, i) => {
            const columnData = [];
            fields.forEach((field, n) => {
                let columnRule = { index: n + 1, value: event[field.name] || '' };
                if (field.name === this.parent.eventFields.startTime || field.name === this.parent.eventFields.endTime) {
                    const styleRule = { fontSize: 12, numberFormat: 'm/d/yyyy h:mm a' };
                    columnRule = extend({}, columnRule, { style: styleRule }, true);
                }
                columnData.push(columnRule);
            });
            rows.push({ index: i + 2, cells: columnData });
        });
        const workSheet = [{ columns: columns, rows: rows }];
        const book = new Workbook({ worksheets: workSheet }, type, this.parent.locale, undefined, separator);
        book.save(name + '.' + type);
    }
    getExportColumns(exportOptions) {
        const exportColumns = exportOptions.fieldsInfo || [];
        if (exportColumns.length === 0) {
            const fields = exportOptions.fields || Object.keys(this.parent.eventFields).map((field) => this.parent.eventFields[`${field}`]);
            fields.forEach((field) => { exportColumns.push({ name: field, text: field }); });
        }
        return exportColumns;
    }
    getModuleName() {
        return 'excelExport';
    }
    destroy() {
        this.parent = null;
    }
}
